import { useCallback } from 'react';
import classNames from 'classnames';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';
import { isMobileClient } from '../../../utils/isMobileClient';
import { useNavigate } from 'react-router';

export type PaginationProps = Pick<ReactPaginateProps, 'onPageChange' | 'pageCount' | 'forcePage'>;

function Pagination(props: PaginationProps) {
  const isMobile = isMobileClient();
  const navigate = useNavigate();

  const changePage = useCallback(
    ({ selected }: { selected: number }) => {
      //selected is 0-based, but offset is 1-based
      const nextPage = selected + 1;

      const currentPath = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);

      searchParams.set('offset', nextPage.toString());

      const newUrl = `${currentPath}?${searchParams.toString()}#article-filters`;

      navigate(newUrl, {
        preventScrollReset: true,
        replace: true,
        flushSync: true,
      });
    },
    [navigate]
  );

  return (
    <ReactPaginate
      className={classNames('react-paginate', 'pagination')}
      activeClassName="pagination--active"
      pageClassName="pagination__page"
      nextClassName="pagination__next"
      previousClassName="pagination__previous"
      breakLabel="..."
      nextLabel="next"
      forcePage={props.forcePage}
      onPageChange={changePage}
      pageCount={props.pageCount}
      previousLabel="prev"
      disableInitialCallback
      pageRangeDisplayed={isMobile ? 1 : 2}
      marginPagesDisplayed={isMobile ? 1 : 2}
    />
  );
}

export default Pagination;
